export default {
  'app.setting.pagestyle': '페이지 스타일 설정',
  'app.setting.pagestyle.dark': '다크 모드',
  'app.setting.pagestyle.light': '라이트 모드',
  'app.setting.content-width': '콘텐츠 너비',
  'app.setting.content-width.fixed': '고정',
  'app.setting.content-width.fluid': '유동',
  'app.setting.themecolor': '테마 색상',
  'app.setting.themecolor.dust': '더스트 레드',
  'app.setting.themecolor.volcano': '볼케이노',
  'app.setting.themecolor.sunset': '선셋 오렌지',
  'app.setting.themecolor.cyan': '시안',
  'app.setting.themecolor.green': '폴라 그린',
  'app.setting.themecolor.daybreak': '데이브레이크 블루 (기본)',
  'app.setting.themecolor.geekblue': '긱 블루',
  'app.setting.themecolor.purple': '골든 퍼플',
  'app.setting.navigationmode': '네비게이션 모드',
  'app.setting.sidemenu': '사이드 메뉴 레이아웃',
  'app.setting.topmenu': '상단 메뉴 레이아웃',
  'app.setting.fixedheader': '헤더 고정',
  'app.setting.fixedsidebar': '사이드바 고정',
  'app.setting.fixedsidebar.hint': '사이드 메뉴 레이아웃에서 작동',
  'app.setting.hideheader': '스크롤 시 헤더 숨김',
  'app.setting.hideheader.hint': '헤더 숨김이 활성화된 경우 작동',
  'app.setting.othersettings': '기타 설정',
  'app.setting.weakmode': '색맹 친화 모드',
  'app.setting.copy': '설정 복사',
  'app.setting.copyinfo':
    '복사 성공, src/models/setting.js의 defaultSettings를 교체하세요',
  'app.setting.production.hint':
    '설정 패널은 개발 환경에서만 표시됩니다. 수동으로 수정하세요',
};
